import React from 'react';
import { CreateSurveyProps } from '../common/CreateSurveyProps';
import { Link } from 'react-router-dom';

import { GetDateString } from '../common/helperFunctions';
import { EditObject } from '../common/constants';
import Header from '../components/header';
import authHeader from '../services/auth-header';

class Search extends React.Component<CreateSurveyProps> {
   
    // This method is called when the component is first added to the document
    public componentDidMount() {
        this.handleSearch(1);
    }

    render() {

        return ( 
            <>
                <Header props={this.props}></Header>
                
                <div className="row g-3">
                    <div className="col-sm-6 col-md-6 col-lg-4">
                        <input type="text"
                        name="searchText"
                        value={this.props.searchState.searchText}
                        placeholder="Compaign Name" className="form-control" onChange={this.handleOnChange} />
                    </div>
                    <div className="col-sm-6 col-md-6  col-lg-4 d-flex align-items-end">
                        <button className="btn btn-success" onClick={()=>this.handleSearch(1)}>Search</button>
                    </div>
            
                    <div className="col-sm-12 table-responsive">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Name</th>
                                    <th># of Links</th>
                                    <th>Status</th>
                                    <th>Submissions</th>
                                    <th>Created On</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th colSpan={3}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.renderSurveyRecords()
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className='col-sm-12'>
                        <nav aria-label="...">
                            <ul className="pagination">
                                {
                                    this.renderPagination()
                                }
                            </ul>
                        </nav>
                    </div>
                </div>

            </>
        );
    }

    handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.target.value = e.target.value;

        this.props.SetPropertyCreateSurvey(EditObject.SearchState, e.target.name, e.target.value, false, 0, new Date());
    }

    handleSearch = (pageNumber: number) => {
        this.props.SetPropertyCreateSurvey(EditObject.SearchState, 'pageNumber', '', false, pageNumber, new Date());

        this.props.RequestSurveyList(this.props.searchState.searchText, this.props.searchState.pageSize, pageNumber);
    }

    handleDelete = (surveyId: number) => {
        fetch(`/Admin/Delete/${surveyId}`, authHeader('DELETE', '', ''))
        .then(response => {
            if (!response.ok) {
              throw new Error('Unable to delete');
            }
            return response;
          })
        .then(data => {
            this.props.RequestSurveyList(this.props.searchState.searchText, this.props.searchState.pageSize, this.props.searchState.pageNumber);
        })
        .catch( error => {

        });
    }

    renderPagination() {
        let li = [];

        
        var totalPages = Math.ceil(this.props.searchState.totalRecords/this.props.searchState.pageSize); 
        
        if (totalPages < 2) return <></>;
        
        if (this.props.searchState.pageNumber === 1) {
            li.push(<li className="page-item disabled"><span className="page-link">&lt;&lt;</span></li>);
        } else {
            li.push(<li className="page-item"><a className="page-link" onClick={() => this.handleSearch(1)}>&lt;&lt;</a></li>);
        }

        let maxLinks = 2;
        let startLink = this.props.searchState.pageNumber - maxLinks;
        let endLink = this.props.searchState.pageNumber + maxLinks;

        if (startLink < 1) {
            endLink += (startLink * -1) + 1;
            startLink = 1;
        }

        if (endLink > totalPages) {
            
            startLink -= (endLink - totalPages);
            endLink = totalPages;
            if (startLink < 1) startLink = 1;
        }


        for(let i = startLink; i <= endLink; i++) {

            if (this.props.searchState.pageNumber === i) {
                li.push(<li className="page-item active" aria-current="page">
                            <span className="page-link">{i}</span>
                        </li>);
            } else {
                li.push(<li className="page-item"><a className="page-link" onClick={() => this.handleSearch(i)}>{i}</a></li>);
            }
        }

        if (this.props.searchState.pageNumber === totalPages) {
            li.push(<li className="page-item disabled"><span className="page-link">&gt;&gt;</span></li>);
        } else {
            li.push(<li className="page-item"><a className="page-link" onClick={() => this.handleSearch(totalPages)}>&gt;&gt;</a></li>);
        }
        return li;
    }

    renderSurveyRecords() {
        if (this.props.searchState.isLoading === 1) {
            return (
                <tr>
                    <td colSpan={9}>
                        <div className="progress">
                            <div className="progress-bar progress-bar-striped progress-bar-animated"
                                role="progressbar" style={{width: '100%'}}></div>
                        </div>
                    </td>
                </tr>
            );
        } else if (this.props.searchState.isLoading === 0) {
            if ( this.props.searchState.survey && this.props.searchState.survey.length > 0 ) {
                return (
                    this.props.searchState.survey.map( m => 
                        {
                            return <tr className='align-middle' key={m.surveyId}>
                                <td>{m.surveyId}</td>
                                <td>{m.name}</td>
                                <td><Link to={{pathname: `/links/${m.surveyId}`}}>{m.numOfLinks}</Link></td>
                                <td>{m.status}</td>
                                <td><Link to={{pathname: `/Submissions/${m.surveyId}`}}>{m.totalSubmissions}</Link></td>
                                <td>{GetDateString(m.createdOn, false)}</td>
                                <td>{m.startDate ? GetDateString(m.startDate, true) : ''}</td>
                                <td>{m.endDate ? GetDateString(m.endDate, true) : ''}</td>
                                <td>
                                    <Link to={`/Edit/0/${m.surveyId}`}>Edit</Link>&nbsp;
                                </td>
                                <td>
                                    <Link to={`/Edit/1/${m.surveyId}`}>Copy</Link>&nbsp;
                                </td>
                                <td>
                                    <div className="dropdown">
                                        <button className="btn btn-sm btn-warning dropdown-toggle my-0" type="button" id={`ddmb${m.surveyId}`} data-bs-toggle="dropdown" aria-expanded="false">Delete</button>
                                        <ul className="dropdown-menu" aria-labelledby={`ddmb${m.surveyId}`}>
                                            <li><a className="dropdown-item" onClick={() => this.handleDelete(m.surveyId)}>Do you want to delete survey '{m.name}'?</a></li>
                                        </ul>
                                    </div>
                                </td>
                            </tr>;
                        }
                    ));
            } else {
                return (
                    <tr>
                        <td colSpan={9}>
                            No records found
                        </td>
                    </tr>
                );
            }
        }

        return (
            <tr>
                <td colSpan={9}>
                    Click search to fetch the records
                </td>
            </tr>
        );
    }
}
 
export default Search;
